import { render, staticRenderFns } from "./AdminEditCalendarEventModal.vue?vue&type=template&id=2527271f"
import script from "./AdminEditCalendarEventModal.vue?vue&type=script&lang=js"
export * from "./AdminEditCalendarEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports